import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger);

export function paFlxIntro() {
    const intros = document.querySelectorAll('.pa-flx-intro');

    if (!intros.length) return;

    intros.forEach((intro) => {
        const pipeL = intro.querySelector('.pipe-h.left .pipe-path');
        const pipeR = intro.querySelector('.pipe-h.right .pipe-path');

        const pipes = [pipeL, pipeR].filter(Boolean);

        if (!pipes.length) return;

        gsap.set(pipes, {
            drawSVG: '0% 0%'
        });

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: intro,
                start: 'top 90%',
                end: 'top 10%',
                scrub: 2
                //once: true
            }
        });

        if (pipeL) {
            tl.to(pipeL, {
                drawSVG: '0% 100%',
                ease: 'linear'
            });
        }

        if (pipeR) {
            tl.to(pipeR, {
                drawSVG: '0% 100%',
                ease: 'linear'
            });
        }
    });
}
